import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=349fe6ab&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349fe6ab')) {
      api.createRecord('349fe6ab', component.options)
    } else {
      api.reload('349fe6ab', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=349fe6ab&", function () {
      api.rerender('349fe6ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WN7Nc6LG93E8/JS/comp/ImgFallback.vue"
export default component.exports